import NetworkApi from './networkApi';
import paths from './path';

const getUserPermissions = async (permissionType = '') => {
  const options = {
    withPermission: true,
    Authorization: `${localStorage.getItem('token')}`,
  };
  const url = paths.getUserPermissions(permissionType);
  const response = await NetworkApi.get(url, options);

  return response;
};

export const fetchDataAccessLists = async () => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  };

  const data = await NetworkApi.get(`${paths.dataAccessListURL}`, headers);

  return data;
};

export const fetchModuleAccessLists = async () => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  };

  const data = await NetworkApi.get(`${paths.moduleAccessListURL}`, headers);

  return data;
};

export default {
  getUserPermissions,
};
